import React from "react";
import { Datepicker } from "Components/DatePicker";
import { SvgRightLarge } from "melodies-source/Svgs/RightLarge";
import styled from "styled-components";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";
import { DateTime } from "luxon";
import { useMobileMediaQuery } from "hooks";

export const DateRange: React.FC = () => {
  const {
    startDateInputValue,
    setStartDate,
    endDateInputValue,
    setEndDate,
    multidayEvent,
    multidayEventLoading,
    multiDayReportRefetching,
  } = useMultiDayEventContext();
  const isMobile = useMobileMediaQuery();

  return (
    <Container>
      <StyledDatepicker
        label="Start Date/Time"
        value={startDateInputValue}
        disabled={multidayEventLoading || multiDayReportRefetching}
        onChange={setStartDate}
        minDate={
          multidayEvent &&
          DateTime.fromMillis(multidayEvent.startsAt.toMillis())
        }
        maxDate={DateTime.now()}
        clearable={false}
      />
      {!isMobile && <SvgRightLarge />}
      <StyledDatepicker
        label="End Date/Time"
        value={endDateInputValue}
        disabled={multidayEventLoading || multiDayReportRefetching}
        onChange={setEndDate}
        maxDate={DateTime.now()}
        clearable={false}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;

  & > svg {
    width: 55px;
    color: var(--secondary-text-color);

    ${({ theme }) => theme.media.mobile} {
      margin: 10px auto;
    }
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    margin-bottom: 0;
    width: 100%;
  }
`;

const StyledDatepicker = styled(Datepicker)`
  width: 330px;
  margin-bottom: 20px;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
